export enum LessonType {
  PubliclyAvailable = 'PUBLICLY_AVAILABLE',
  Basic = 'BASIC',
  Supplement = 'SUPPLEMENT',
  Kriya = 'KRIYA',
  Advanced = 'ADVANCED'
}
